import { IProjectionMeshBase } from "@dreamcam/projection-mesh-common/dist";

export interface IScene<TEngine = any> {
    get projectionMesh(): IProjectionMeshBase;
    get engine(): TEngine;
    sceneColor: string;
    zoomSensitivity: number;
    touchMoveXSensitivity: number;
    touchMoveYSensitivity: number;
    zoomMin: number;
    zoomMax: number;
    touchZoomMode: 'pinch' | 'scroll';
    requireReleaseAfterZoom: boolean;
    mouseMoveXSensitivity: number;
    mouseMoveYSensitivity: number;
    rotationXLimit: number;
    rotationYLimit: number;
    currentZoom: number;
    zoom(value: number): void;
}